import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const META = {
  shirts: { title: "SHIRTS", tag: "Classic · Casual · Formal", desc: "From tailored oxfords to breezy linen — for men and women." },
  jeans:  { title: "JEANS",  tag: "Skinny · Straight · Wide-Leg · Mom", desc: "Premium denim in every fit that matters. Men and women." },
};

export default function Basics({ sub }) {
  const loc = useLocation();
  const [all, setAll] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { subcategory: sub } }).then((r) => setAll(r.data));
  }, [sub, loc.pathname]);

  const men = useMemo(() => all.filter((p) => p.category === "men"), [all]);
  const women = useMemo(() => all.filter((p) => p.category === "women"), [all]);
  const m = META[sub];

  return (
    <div>
      <div className="relative bg-[#0F0B08] text-[#F0E5D0] overflow-hidden border-b border-[#D4B25C]/10">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <p className="label-tag text-[#D4B25C]/60 mb-4">{m.tag}</p>
            <h1 className="font-display text-6xl sm:text-7xl font-black leading-none">
              {m.title.slice(0, m.title.length - 1)}<span className="text-[#D4B25C]">{m.title.slice(-1)}.</span>
            </h1>
            <p className="mt-6 text-white/70 max-w-md">{m.desc}</p>
          </div>
          <div className="hidden md:block relative h-80">
            <img src={sub === "shirts" ? "https://images.unsplash.com/photo-1602810316693-3667c854239a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" : "https://images.unsplash.com/photo-1542272604-787c3835535d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"} alt="" className="absolute inset-0 w-full h-full object-cover rounded-md" />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <Tabs defaultValue="all">
          <TabsList>
            <TabsTrigger data-testid={`bs-${sub}-tab-all`} value="all">All ({all.length})</TabsTrigger>
            <TabsTrigger data-testid={`bs-${sub}-tab-men`} value="men">Men ({men.length})</TabsTrigger>
            <TabsTrigger data-testid={`bs-${sub}-tab-women`} value="women">Women ({women.length})</TabsTrigger>
          </TabsList>
          {[["all", all], ["men", men], ["women", women]].map(([k, arr]) => (
            <TabsContent key={k} value={k} className="mt-8">
              {arr.length === 0 ? (
                <p className="text-center text-muted-foreground py-20">Nothing here yet.</p>
              ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                  {arr.map((p) => <ProductCard key={p.id} p={p} />)}
                </div>
              )}
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
